<template>
  <perfect-scrollbar
    ref="scrollbar"
    v-bind="$props"
    @scroll="handleScroll">
    <slot />
  </perfect-scrollbar>
</template>

<script>
export default {
  name: 'BaseScrollbar',
  props: {
    viewClass: {
      type: String,
    },
    scrollPosition: {
      // from 0 to 1
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      emitted: false,
    };
  },
  methods: {
    handleScroll(e) {
      if (!scrollbar) this.$emit('scrolly', e.target.scrollTop);

      const scrollbar = this.$refs.scrollbar.ps;
      this.$refs.scrollbar.update()
      if (!scrollbar.native) {
        const scrollPercentage = Math.round((100 / (parseFloat(scrollbar.containerHeight) / (scrollbar.scrollbarYHeight + scrollbar.scrollbarYTop))));
        this.$emit('handleScroll', scrollPercentage + (parseFloat(scrollbar.sizeHeight) / 2));
        this.$emit('scrolly', scrollbar.scrollbarYTop);
        if (scrollPercentage < 100) {
          this.emitted = false;
        }
        if (scrollPercentage <= 20) {
          this.$emit('scrollystart');
        }
        if (scrollPercentage === 100) {
          this.$emit('scrollyend');
        }
      }
    },
  },
  mounted() {
    if (this.scrollPosition > 0 && this.scrollPosition < 1) {
      this.$nextTick(() => this.$refs.scrollbar.wrap.scrollTop = this.$refs.scrollbar.wrap.scrollHeight * this.scrollPosition)
    }
  }
};
</script>
<style lang="scss">

</style>
